<script>
	export default {
		name: 'CaseExecuter',
		methods: {
			// reference: http://webdesign-dackel.com/2015/05/15/js-change-case
			// case styles: camelCase / PascalCase / snake_case / kebab-case
			convertCaseToCamel(target){
				const self_ = this;

				if(self_.isFalse(target)) { return null }

				target = target.charAt(0).toLowerCase() + target.slice(1);
				return target.replace(/[-_](.)/g, (match, group1) => {
					return group1.toUpperCase();
				});
			},
			convertCaseToKebab(target){
				const self_ = this;

				if(self_.isFalse(target)) { return null }

				var camel = self_.convertCaseToCamel(target);
				return camel.replace(/[A-Z]/g, string => {
					return "-" + string.charAt(0).toLowerCase();
				});
			},
			convertCaseToPascal(target){
				const self_ = this;

				if(self_.isFalse(target)) { return null }

				var camel = self_.convertCaseToCamel(target);
				return camel.charAt(0).toUpperCase() + camel.slice(1);
			},
			convertCaseToSnake(target){
				const self_ = this;

				if(self_.isFalse(target)) { return null }

				var camel = self_.convertCaseToCamel(target);
				return camel.replace(/[A-Z]/g, string => {
					return "_" + string.charAt(0).toLowerCase();
				});
			}
		}
	}
</script>